import type { ShortAnswerQuestion as ShortAnswerType } from '@/types/question-types';
import styles from './PlaceholderQuestion.module.scss';

interface ShortAnswerQuestionProps {
  question: ShortAnswerType;
  userAnswer?: string;
  onAnswer: (answer: string) => void;
  showExplanation?: boolean;
  isReviewMode?: boolean;
}

/**
 * Placeholder for Short Answer questions
 * TODO: Implement full short-answer functionality in Phase 4
 */
export function ShortAnswerQuestionPlaceholder({
  question,
  showExplanation,
}: ShortAnswerQuestionProps) {
  return (
    <div className={styles.placeholder}>
      <div className={styles.placeholder__badge}>Coming Soon</div>
      <h3 className={styles.placeholder__title}>Short Answer Question</h3>
      <p className={styles.placeholder__question}>{question.question_text}</p>
      <p className={styles.placeholder__info}>
        This question type will be available in a future update. For now, you can review the question above.
      </p>
      {showExplanation && (
        <div className={styles.placeholder__explanation}>
          <strong>Explanation:</strong> {question.explanation}
        </div>
      )}
    </div>
  );
}
